module.exports = __webpack_public_path__ + "static/media/logo.d8fe1ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 943
// module chunks = 0